<div class="navigations">
  <app-crm-navigation-item
    *ngFor="let item of navigations"
    [item]="item">
  </app-crm-navigation-item>
</div>
